<ng-container *ngIf="qr_categories.MEMORIES === qr_category">

    <app-navbar class="home" [show_cart]="true" [hide_menu]="true"
        home_address="/branded-qr-code-for-memories"></app-navbar>
    <app-core-products-menu [qr_category]="qr_category"></app-core-products-menu>

    <section class="first-section {{qr_category}}">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <p>Capture and Share Your Event Memories Effortlessly!</p>
                    <h1 class="lg">Make your <span>events unforgettable</span> with Memories, our innovative QR Code
                        system that lets
                        your <span>guests upload photos and videos</span> directly to a <span>centralised online
                            gallery</span>.</h1>
                </div>
                <div class="col-md-6 mt-5 mt-md-0">
                    <div class="video-container" (click)="openModal()">
                        <i class="bi bi-play"></i>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="steps">
        <img loading="lazy" src="assets/landing/pattern-top-darker.png" width="30%" class="pattern-top">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h1 class="double-xl">How it works</h1>
                </div>
            </div>
            <div class="row align-items-end">
                <div class="col-md-6 share-text">
                    <h1 class="triple-xl">1.</h1><br>
                    <h1 class="xl">Share</h1>
                    <h2>
                        Display the code prominently at your event - on signage, posters, or even print it on
                        invitations.
                    </h2>
                </div>
                <div class="col-md-6 mt-5 mt-md-0">
                    <img loading="lazy" src="assets/products/step-share.png" alt="Brand qr codes memories step 1"
                        width="100%" />
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 class="triple-xl">2.</h1><br>
                    <h1 class="xl">Capture</h1>
                    <h2>
                        Your guests scan the code with their smartphones, upload their photos and videos directly to the
                        online gallery. No app downloads or registrations required!
                    </h2>
                </div>
                <div class="col-md-6 mt-5 mt-md-0">
                    <img loading="lazy" src="assets/products/step-capture.png" alt="Brand qr codes memories step 2"
                        width="100%" />
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 class="triple-xl">3.</h1><br>
                    <h1 class="xl">Relive the Fun</h1>
                    <h2>
                        After the event, visit your dashboard to see all the captured moments, download and reminisce
                        about the special day!
                    </h2>
                </div>
                <div class="col-md-6 mt-5 mt-md-0 step-enjoy-img">
                    <img loading="lazy" src="assets/products/step-enjoy.png" alt="Brand qr codes memories step 3"
                        width="100%" />
                </div>
            </div>
        </div>
        <img loading="lazy" src="assets/landing/pattern-bottom-darker.png" width="30%" class="pattern-bottom">
    </section>

    <section class="third-section">
        <div class="container">
            <div class="row mb-5 pb-5">
                <div class="col-lg-12 text-center">
                    <h1 class="double-xl">Perfect for</h1>
                </div>
            </div>
            <app-core-product-use-cases-wrapper [qr_category]="qr_category"></app-core-product-use-cases-wrapper>
        </div>
    </section>

    <section class="useful-analytics">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h1 class="xl">Useful analytics</h1>
                    <img loading="lazy" class="mt-5" src="assets/landing/analytics.png"
                        alt="Brand qr codes effortless set up" width="100%" />
                </div>
            </div>
        </div>
    </section>

    <section class="pop-up">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <h1 class="xl text-white mb-5">Collect and build R.S.V.P. list with <br> Pop-up forms</h1>
                    <p>Easily create user-friendly pop-up forms for any of your dynamic QR codes to collect event
                        attendees.</p>
                    <a class="btn btn-secondary btn-lg mb-5" routerLink="/pop-up-form">
                        Learn more
                        <i class="bi bi-chevron-right me-2"></i>
                    </a>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-8 col-sm-10 col-10">
                    <img loading="lazy" src="assets/landing/pop-up-2.png" alt="Brand qr codes effortless set up"
                        width="100%" />
                </div>
            </div>
        </div>
        <img loading="lazy" src="assets/landing/patern-bottom.png" width="30%" class="patern-bottom">
    </section>

    <section class="features">
        <div class="container">
            <div class="d-flex flex-column justify-items-center mb-5">
                <h1 class="xl mb-5 text-center">Benefits</h1>
                <h3 class="text-center">
                    BrandQRcodes is your gateway to transforming QR Codes into captivating <span>digital
                        experiences</span>. We
                    offer user-friendly design tools, <span>affordability</span>, and unmatched customisation options to
                    ensure
                    your brand stands out effortlessly.
                </h3>
                <div class="text-center mt-5">
                    <a class="btn btn-secondary btn-lg mb-5"
                        [ngStyle]="{'visibility': products?.length ? 'visible' : 'hidden'}"
                        (click)="functionService.scrollToTop()">
                        <i class="bi bi-cart me-2"></i>
                        Buy Now
                    </a>
                </div>
            </div>
            <div class="row g-3">
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>1. Effortless Photo Sharing</h5>
                        <p class="lg">Guests can upload photos and videos instantly with just a scan - instantly share
                            memories with you, other guests and their social media platforms!</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>2. Centralised Gallery</h5>
                        <p class="lg">All your event photos and videos are gathered in one convenient location, making
                            it easy to relive the moments.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>3. No App Downloads</h5>
                        <p class="lg">All that is needed is their smartphones to capture and upload photos directly to
                            your online gallery. No app download required for your guests!</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>4. Easy Management</h5>
                        <p class="lg">Manage the gallery, download photos, and share them with ease. Customise your
                            online gallery, moderate content, and download or share photos with ease. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>5. Multiple Packages</h5>
                        <p class="lg">Big or small, we have you covered! Choose a package with the perfect access time,
                            and features to match your event size and budget. </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6">
                    <div class="feature-box">
                        <h5>6. Boosts Social Media Engagement</h5>
                        <p class="lg">Allow social media sharing buttons within the gallery to enable guests to easily
                            share their favourite event photos directly to their social media platforms.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="container">
        <app-core-faqs-landing-page [category]="faq_category"></app-core-faqs-landing-page>
    </div>

</ng-container>

<div class="modal fade" [id]="memories_modal_id" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content transparent text-center">
            <iframe [width]="device.isMobile() ? '100%': 560" [height]="device.isMobile() ? 600: 700"
                [src]="memories_video_src_1 | safeUrl" title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
    </div>
</div>

<app-footer>
    <a class="btn btn-secondary btn-lg mb-5" [ngStyle]="{'visibility': products?.length ? 'visible' : 'hidden'}"
        (click)="functionService.scrollToTop()">
        <i class="bi bi-cart me-2"></i>
        Buy Now
    </a>
</app-footer>

<app-shared-bounce-modal *ngIf="!memories_video_src_1"></app-shared-bounce-modal>